//Lead page
export const LEADS_PAGE_NEW_TAB = "New";
export const LEADS_PAGE_INPROGRESS_TAB = "In Progress";
export const LEADS_PAGE_CONVERTED_TAB = "Converted";
export const LEADS_PAGE_ALL_TAB = "All";
